module.exports = __webpack_public_path__ + "static/media/自転車競技部展示.52f188e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/自転車競技部展示.png
// module id = 325
// module chunks = 10